import { Div, Span } from "@tblabs/truffle";
import { ConnectingLineV0 } from "../Components/ConnectingLine";
import { StepsMarker } from "../Services/StepsMarker";
import { StepStylist } from "../Services/StepStylist";
import { Step } from "../Steps/Step/Step";
import { MarkedStep } from "../Models/MarkedStep";
import { Order } from "../Models/Order";
import { CustomerStepPrinter } from "../Components/CustomerStepPrinter";


export class StepsPrinter extends Div
{
    private stepsBox = new Div("blocks-container")
    private dotButtonsBox = new Div("buttons")

    constructor(
        private steps: Step<any>[],
        private perspective: "admin" | "customer",
        private printer: (step: MarkedStep) => Div,
        private autoScrollToCurrent: boolean = true)
    {
        super("StepsPrinter");

        this.Append(
            this.stepsBox, this.dotButtonsBox
        );

        this.Refresh();
    }

    private Refresh(): this
    {

        this.stepsBox.Clear();
        this.dotButtonsBox.Clear();

        let i = 0;
        let c: Div | undefined;
        let lastClickedButton;

        const stylist = new StepStylist();
        const markedSteps = StepsMarker.Mark(this.steps);

        for (const markedStep of markedSteps)
        {
            if (this.perspective == "customer" && !markedStep.Step.Data.VisibleForCustomer.value)
                continue;

            // console.log("StepsPrinter Refresh", markedStep.Step.Title());
            if (this.perspective == "customer" && !markedStep.Step.IsVisibleForCustomer)
                continue;

            if (i > 0)
                this.stepsBox.Append(new ConnectingLineV0());
            i++;

            const stepBox = this.printer(markedStep);
            const dotButton = new Span("●").Class("switch-btn")
                .OnClick(_ =>
                {
                    lastClickedButton?.Style(`text-shadow: none`);
                    lastClickedButton = _;
                    _.Style(`text-shadow: #3b82f6 1px 0 10px;`);
                    stepBox.Element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
                });

            if (markedStep.IsCurrent)
            {
                c = stepBox;
                dotButton.Color("#3b82f6");
            }

            stylist.Style(markedStep, stepBox);

            this.stepsBox.Append(stepBox);
            this.dotButtonsBox.Append(dotButton);

            // TO POWODUJE ROZPIERDOL, leci milion refreshy i nie wiem dlaczego
            // markedStep.Step.Data.State
            //     .ClearHandlers()
            //     .OnChange(() =>
            //     {
            //         this.Refresh();
            //     });

            if (!c && i == this.steps.length - 1)
                c = stepBox;
        }

        // NIE ZA BARDZO ROZUMIEM DLACZEGO DZIAŁA Z TIMEOUTEM DOPIERO, PRZECIEŻ WSZYSTKIE TE ELEMENTY SA JUŻ DAWNO APPENDOWANE
        if (this.autoScrollToCurrent)
            setTimeout(() =>
            {
                c?.Element?.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
            }, 1);

        return this;
    }
}



export class StepsPrinterV2 extends Div
{
    private stepsBox = new Div("blocks-container vertical")
    private dotButtonsBox = new Div("buttons")

    constructor(
        private steps: Step<any>[],
        private perspective: "admin" | "customer",
        private printer: (step: MarkedStep) => Div)
    {
        super("StepsPrinter");

        this.Append(
            this.stepsBox, this.dotButtonsBox
        );

        this.Refresh();
    }

    private Refresh(): this
    {
        // console.log("StepsPrinterV2 Refresh");
        this.stepsBox.Clear();

        // const stylist = new StepStylist();
        const markedSteps = StepsMarker.Mark(this.steps);

        for (const markedStep of markedSteps)
        {
            // console.log("StepsPrinterV2 Refresh", markedStep.Step.Title);
            if (!markedStep.Step.Data.VisibleForCustomer.value)
                continue;

            // TODO: TO REMOVE
            if (this.perspective == "customer" && !markedStep.Step.IsVisibleForCustomer)
                continue;
            /////

            const stepBox = this.printer(markedStep);

            // stylist.Style(markedStep, stepBox);

            this.stepsBox.Append(stepBox);

            markedStep.Step.Data.State
                .ClearHandlers()
                .OnChange(() =>
                {
                    this.Refresh();
                });

        }

        return this;
    }
}



export class CustomerStepsPrinter extends StepsPrinter
{
    constructor(order: Order)
    {
        super(order.Steps.Items, "customer", (step) => new CustomerStepPrinter(step), true);
    }
}